import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D3EFEC",
      "fill-rule": "evenodd",
      d: "M1.787.4A1.6 1.6 0 0 0 .187 2v8a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6V2a1.6 1.6 0 0 0-1.6-1.6zm9.6 9.6h-9.6l3.2-6.4 2.4 4.8 1.6-3.2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }